import { withErrorBoundary } from "@sentry/nextjs";
import { gql } from "graphql-request";
import { VFC } from "react";
import styled from "styled-components";
import { Markdown, SupTitle } from "components";
import { useAnchor } from "hooks";
import { Title4Content } from "types/graphql/generated";

interface Props {
  className?: string;
  content: Title4Content;
}

const Title4: VFC<Props> = withErrorBoundary(({ content: { title4SupTitle, title } }) => {
  useAnchor("title4");

  return (
    <StyledTitle className="title4 Content">
      {title4SupTitle && <SupTitle className="Title4SupTitle">{title4SupTitle}</SupTitle>}
      <Markdown className="Font_48_54_600 md:Font_40_48_600 sm:Font_32_40_600">{title}</Markdown>
    </StyledTitle>
  );
}, {});

const StyledTitle = styled.section`
  margin-top: -64px;
  padding-top: 64px;

  .Title4SupTitle {
    margin-bottom: 32px;

    &::before {
      margin-right: 16px;
    }
  }
`;

gql`
  fragment Title4Content on ComponentTitleTitle4 {
    title4SupTitle
    title
  }
`;

export { Title4 };
export type { Props as Title4Props };
